export { default as Text } from './component';
export { default as useText } from './hook';
